import {Buffer} from 'buffer';

export const encodeData=(name)=>{
 return 'Basic '+ Buffer.from(name).toString('base64');
}
export const decodeData=(name)=>{
  return  Buffer.from(name, 'base64').toString('ascii')
}